var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.715576,
    width: 34.2067,
    height: 34.2067,
    rx: 8,
    fill: "#3838D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85535 21.8188H9.49727V14.4302L12.4664 21.8188H13.0548L15.9692 14.4302V21.8188H17.789V12.0357H15.3808L12.8632 18.7129L10.2909 12.0357H7.85535V21.8188ZM24.3108 21.9557C26.6368 21.9557 28.3061 20.7653 28.5935 18.4119H26.8147C26.6232 19.7938 25.6654 20.4779 24.3108 20.4779C22.5047 20.4779 21.4511 19.1781 21.4511 16.9752V16.8657C21.4511 14.6765 22.5731 13.3356 24.2971 13.3356C25.7064 13.3356 26.4316 14.006 26.6368 15.3059H28.484C28.2651 13.0072 26.5274 11.8852 24.2834 11.8852C21.5606 11.8852 19.5355 13.9376 19.5355 16.8794V16.9889C19.5355 19.9991 21.2459 21.9557 24.3108 21.9557Z",
    fill: "#EFEFFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile3.088f1d0fc9ef758eec5c5faef21cd7c3.svg";
export { ForwardRef as ReactComponent };